var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "class-header-content" },
    [
      _c("TableList", {
        attrs: {
          tableData: _vm.tableData,
          columns: _vm.columns,
          bordered: "",
          loading: _vm.loading,
          scroll: () => {},
          rowClassName: _vm.rowClassName,
        },
        scopedSlots: _vm._u([
          {
            key: "studentCount",
            fn: function ({ record }) {
              return [
                _c(
                  "div",
                  {
                    staticClass: "cell",
                    on: {
                      click: function ($event) {
                        return _vm.goDetail(record, 0)
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "total" }, [
                      _vm._v(_vm._s(record.timeStats.studentCount || 0)),
                    ]),
                    record.timeStats.pendingCount > 0
                      ? _c("span", { staticClass: "pending" }, [
                          _vm._v(
                            "\n          未处理 " +
                              _vm._s(record.timeStats.pendingCount) +
                              "\n        "
                          ),
                        ])
                      : _vm._e(),
                  ]
                ),
              ]
            },
          },
          {
            key: "continuousStatsCount",
            fn: function ({ record }) {
              return [
                _c(
                  "div",
                  {
                    staticClass: "cell",
                    on: {
                      click: function ($event) {
                        return _vm.goDetail(record, 1)
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "total" }, [
                      _vm._v(
                        _vm._s(record.timeStats.continuousStatsCount || 0)
                      ),
                    ]),
                    record.timeStats.continuousStatsPendingCount > 0
                      ? _c("span", { staticClass: "pending" }, [
                          _vm._v(
                            "\n          未处理 " +
                              _vm._s(
                                record.timeStats.continuousStatsPendingCount
                              ) +
                              "\n        "
                          ),
                        ])
                      : _vm._e(),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }